import React, { useEffect, useRef } from 'react';
import PremiumSectionContainer from '../components/PremiumSectionContainer';
import PremiumSection from '../components/PremiumSection';
import { InfoMessage } from '../components/InfoMessage';

export const TicketFormErrorInfoBlock = (props) => {
  const ref = useRef(null);

  useEffect(() => {
    // ref.current?.scrollIntoView();
  }, []);

  return (
    <PremiumSectionContainer ref={ref} {...props}>
      <PremiumSection>
        <InfoMessage>{props.backendErrorsMsg}</InfoMessage>
      </PremiumSection>
    </PremiumSectionContainer>
  );
};
